import { useAppDispatch, useAppSelector } from 'app/hooks';
import Select from 'components/inputs/select';
import {
  setPartialStructure,
  setStructureSubtypeId,
  setStructureTypeId
} from 'features/structure';
import { confirmationModal } from 'utils/ui';

type StructureTypeSelectorProps = {
  showInvalid?: boolean;
  loading?: boolean;
};

export default function StructureTypeSelector({
  showInvalid,
  loading
}: StructureTypeSelectorProps) {
  const dispatch = useAppDispatch();
  const { structureTypeId } = useAppSelector((state) => state.structure);
  const { configurations } = useAppSelector((state) => state.configurations);
  const { structure } = useAppSelector((state) => state.structure);
  const { selectedSystems } = useAppSelector((state) => state.systems);
  const { structureTypes } = useAppSelector((state) => state.data);

  const handleChangeStructureType = (newStructureTypeId: number | null) => {
    if (newStructureTypeId === structureTypeId) {
      return;
    }

    const changeStructureType = () => {
      dispatch(setStructureTypeId(newStructureTypeId));
      dispatch(setStructureSubtypeId(null));
      dispatch(setPartialStructure(null));
    };
    if (
      structure.length === 0 &&
      configurations.length === 0 &&
      selectedSystems.length === 0
    ) {
      changeStructureType();
    } else {
      confirmationModal(
        'Are you sure you want to change the structure type? This will reset your structure, configurations, and selected systems!',
        changeStructureType
      );
    }
  };

  return loading ? (
    <Select placeholder='Loading...' disabled />
  ) : (
    <Select
      onChange={(value) =>
        handleChangeStructureType(value !== '' ? Number(value) : null)
      }
      options={structureTypes.map((t) => ({
        label: t.label,
        value: t.id.toString()
      }))}
      value={structureTypeId?.toString() ?? undefined}
      invalid={showInvalid && structureTypeId === null}
    />
  );
}
